var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h4',{staticClass:"mb-2"},[_vm._v(" User Status ")]),_c('settings-view',{attrs:{"settings":_vm.settings,"form":_vm.form,"is-loading":_vm.isProcessing}}),_c('hr'),_c('b-button',{staticClass:"float-right",attrs:{"variant":"primary","disabled":_vm.isProcessing},on:{"click":_vm.changeUserStatusInProject}},[_vm._v(" Save ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }